import { Component, OnInit, ViewChild, TemplateRef} from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';
import { ColumnMode, DatatableComponent } from '@swimlane/ngx-datatable';
import { CONFIGCONSTANTS } from '../config/app-constants';
import { OrderService } from '../_services/order.service';
import { Router } from '@angular/router';

// Sr.NO HTML

// <ngx-datatable-column
//   name="{{ 'SR_NO' | translate }}"
//   headerClass="no-sorting text-center"
//   prop="srNum"
//   [sortable]="false"
//   [width]="70"
// >
//   <ng-template let-value="value" ngx-datatable-cell-template>
//     <div class="text-center">{{ value }}</div>
//   </ng-template>
// </ngx-datatable-column>
@Component({
  selector: 'app-order-list',
  template: `
    <div class="modal-content">
      <div class="modal-header bg-primary">
        <h5 class="modal-title">
          <i class="fa fa-cart-plus modal-icon"></i>
          {{ "ORDER_LIST" | translate }}
        </h5>
        <button type="button" class="close" (click)="decline()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="row">
          <div class="col-md-12">
            <div class="form-group show-select">
              <label
                >{{ "SHOW" | translate }}
                <select
                  name="showRecords"
                  [(ngModel)]="size"
                  (change)="changeLimit(size)"
                  class="form-control"
                >
                  <option [value]="limit" *ngFor="let limit of limitList">{{
                    limit
                  }}</option>
                </select>
                {{ "ENTRIES" | translate }}
              </label>
            </div>
          </div>
        </div>
        <div class="wrap-datatable pos-rel">
        <div *ngIf="loadingIndicator" class="processing">Processing...</div>
              <ngx-datatable
                [rows]="orderList"
                class="material fullscreen"
                headerHeight="headerHeight"
                footerHeight="footerHeight"
                rowHeight="rowHeight"
                [reorderable]="reorderable"
                [columnMode]="ColumnMode.force"
                #datatable
                [scrollbarH]="scrollbarH"
                [externalSorting]="serverSorting"
                (sort)="onSort($event)"
                [sorts]="[{ prop: sortParam, dir: sortOrder }]"
                [externalPaging]="serverPaging"
                [count]="totalReords"
                [offset]="pageNumber"
                [limit]="size"
                (page)="setPage($event)"
                [messages]="dtMessages"
              >
              <ngx-datatable-column
                  name="{{ 'ORDER_NO' | translate }}"
                  [sortable]="false"
                  prop="order_no"
                >
                <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
                  <ng-template
                      [ngxPermissionsOnly]="['ORDER_VIEW', 'SUPER_ADMIN']"
                      [ngxPermissionsOnlyThen]="thenBlockId"
                      [ngxPermissionsOnlyElse]="elseBlockId">
                  </ng-template>
                  <ng-template #elseBlockId>
                    <div class="text-center">{{ value}}</div>
                  </ng-template>
                  <ng-template #thenBlockId>
                    <div class="text-center">
                      <a class="view-link" title="{{ 'VIEW' | translate }}" (click)="goToViewPage(row.uuid)">{{ value }}</a>
                    </div>
                  </ng-template>
                </ng-template>
                </ngx-datatable-column>
              <ngx-datatable-column
              name="{{ 'PATIENT_NAME' | translate }}"
              prop="patient_firstname"
              [sortable]="false"
            >
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <span *ngIf="row.patient_firstname || row.patient_lastname">{{row.patient_firstname}} {{row.patient_lastname}}</span>
              <div *ngIf="!row.patient_firstname && !row.patient_lastname" class="text-center">{{noColumnRecordText}}</div>
            </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="{{ 'DOCTOR_NAME' | translate }}"
              prop="doctor_firstname"
              [sortable]="false"
            >
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <span *ngIf="row.doctor_firstname || row.doctor_lastname">{{row.doctor_firstname}} {{row.doctor_lastname}}</span>
              <div *ngIf="!row.doctor_firstname && !row.doctor_lastname">{{row.referred_by ? row.referred_by : noColumnRecordText}}</div>
            </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="{{ 'PHARMACY_NAME' | translate }}"
              prop="pharmacy_firstname"
              [sortable]="false"
            >
            <ng-template let-value="value" let-row="row" ngx-datatable-cell-template>
              <span *ngIf="row.pharmacy_firstname || row.pharmacy_lastname">{{row.pharmacy_firstname}} {{row.pharmacy_lastname}}</span>
              <div *ngIf="!row.pharmacy_firstname && !row.pharmacy_lastname" class="text-center">{{noColumnRecordText}}</div>
            </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="{{ 'ORDER_DATE' | translate }}"
              prop="created_at"
              [sortable]="false"
              [minWidth]="170"
            >
              <ng-template let-value="value" ngx-datatable-cell-template>
                {{ value | customDate: momentDateTime24Format }}
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="{{ 'STATUS' | translate }}"
              prop="status"
              [sortable]="false"
              headerClass="text-center"
            >
              <ng-template let-value="value" ngx-datatable-cell-template>
                <div class="text-center">
                  <span [ngClass]="getStatusClass(value)" class="badge">{{
                    value
                  }}</span>
                </div>
              </ng-template>
            </ngx-datatable-column>
            <ngx-datatable-column
              name="{{ 'ACTION' | translate }}"
              prop="id"
              [frozenRight]="piningRight"
              [sortable]="false"
              [maxWidth]="70"
              headerClass="text-center no-sorting"
              *ngxPermissionsOnly="[
                'SUPER_ADMIN',
                'ORDER_VIEW'
              ]"
            >
              <ng-template
                let-value="value"
                let-row="row"
                ngx-datatable-cell-template
              >
                <div class="text-center action-btn">
                  <a
                    *ngxPermissionsOnly="['ORDER_VIEW', 'SUPER_ADMIN']"
                    (click)="goToViewPage(row.uuid)"
                    title="{{ 'VIEW' | translate }}"
                    ><i class="fa fa-eye fa-lg"></i
                  ></a>
                </div>
              </ng-template>
            </ngx-datatable-column>
              </ngx-datatable>
            </div>
      </div>
    </div>
  `,
  styleUrls: []
})
export class OrderConnectionListComponent implements OnInit {
  id: any;
  moduleType: string;
  orderList: any[] = [];
  // Get datatble configuration -- start
  loadingIndicator = false;
  reorderable = CONFIGCONSTANTS.datatableConfig.reorderable;
  scrollbarH = CONFIGCONSTANTS.datatableConfig.scrollbarH;
  serverSorting = CONFIGCONSTANTS.datatableConfig.serverSorting;
  serverPaging = CONFIGCONSTANTS.datatableConfig.serverPaging;
  piningRight = CONFIGCONSTANTS.datatableConfig.piningRight;
  headerHeight = CONFIGCONSTANTS.datatableConfig.headerHeight;
  footerHeight = CONFIGCONSTANTS.datatableConfig.footerHeight;
  rowHeight = CONFIGCONSTANTS.datatableConfig.rowHeight;
  limitList: any[] = CONFIGCONSTANTS.datatableConfig.limitList;
  ColumnMode = ColumnMode;
  totalReords = CONFIGCONSTANTS.datatableConfig.page.totalReords;
  pageNumber = CONFIGCONSTANTS.datatableConfig.page.pageNumber;
  size = CONFIGCONSTANTS.datatableConfig.page.size;
  dtMessages = CONFIGCONSTANTS.datatableConfig.dtMessages;
  @ViewChild(DatatableComponent, { static: false }) datatable: DatatableComponent;
  sortParam = '';
  sortOrder = '';
  // Get datatble configuration -- end
  momentDateTime24Format = CONFIGCONSTANTS.momentDateTime24Format || 'MM/DD/YYYY hh:mm:ss';
  momentDateFormat = CONFIGCONSTANTS.momentDateFormat || 'MM/DD/YYYY';
  readonly noColumnRecordText = CONFIGCONSTANTS["dataTableListing"]["columnRecordMissingText"];
  constructor(
    private orderService: OrderService,
    public modalRef: BsModalRef,
    private router: Router,
    private modalService: BsModalService) {

  }
  ngOnInit() {
    this.getOrderConnectionList();
  }
  goToViewPage(uuid) {
    this.decline();
    this.router.navigate( ['/order-management/view/' + uuid ]);
  }
  /**
   * Get status class from configuration
   * @param status Active/Inactive/Penging
   */
  public getStatusClass(status) {
    if (status) {
      return CONFIGCONSTANTS.statusClass[status];
    } else {
      return 'badge-primary';
    }
  }
  /**
   * Sort datatable fields
   * @param event event was triggered, start sort sequence
   */
  public onSort(event) {
    this.sortParam = event.sorts[0].prop;
    this.sortOrder = event.sorts[0].dir;
    this.rerender(false);
  }

  /**
   * Populate the table with new data based on the page number
   * @param page The page to select
   */
  public setPage(pageInfo) {
    this.pageNumber = pageInfo.offset;
    this.rerender(false);
  }
  /**
   * Show number of records in datatable
   * @param value show total entries value 10,25,50,100
   */
  public changeLimit(value) {
    this.size = value;
    this.rerender(true);
  }
  /**
   * API call and refresh datatable value
   * @param goFirstPage set first page when param value true
   */
  private rerender(goFirstPage): void {
    if (goFirstPage) {
      this.pageNumber = 0;
    }
    this.getOrderConnectionList();
  }
  getOrderConnectionList() {
    this.loadingIndicator = true;
    this.orderService.getOrdersConnectionList({
      start: (this.pageNumber) * (this.size),
      length: this.size,
      user_type: this.moduleType === 'PATIENT' ? 'Patient' : 'Pharmacy',
      user_id: this.id
      // sort_param: this.sortParam,
      // sort_type: this.sortOrder
    })
      .pipe(first())
      .subscribe(resp => {
        this.loadingIndicator = false;
        const respData = resp.data['original'];
        this.orderList = respData.data;
        this.totalReords = respData.recordsTotal;
      }, error => {
        this.loadingIndicator = false;
      });
  }
  decline(): void {
    this.modalRef.hide();
  }
}
